import template from "./settings-quote-numbers-row.html";

const SettingsQuoteNumbersRowComponent = {
  bindings: {
    quoteNumber: "<",
    onChange: "&",
  },
  template: template,
  controller: class SettingsQuoteNumbersRowController {
    /* @ngInject */
    constructor($rootScope, $state, OrganizationService) {
      this.$rootScope = $rootScope;
      this.$state = $state;
      this.OrganizationService = OrganizationService;
    }

    $onInit() {
      this.saving = false;
    }

    $onChanges(changes) {
      this.originalValue = Number(changes.quoteNumber.currentValue.nextNumber);
      this.nextNumber = Number(changes.quoteNumber.currentValue.nextNumber);
      this.default = Boolean(changes.quoteNumber.currentValue.default);
    }

    async save() {
      if (!this.form.$valid || !this.default) return;

      this.saving = true;
      await this.OrganizationService.editQuoteNumber(
        this.quoteNumber._id,
        this.nextNumber,
        this.default
      );
      this.saving = false;
      this.$state.reload();
      this.$rootScope.$applyAsync();
    }
  },
};

export default SettingsQuoteNumbersRowComponent;
